// extracted by mini-css-extract-plugin
export default {"root":"Tasks_root__vipOE","egg":"Tasks_egg__hejrL","grid":"Tasks_grid__oRzih"};